import { Car, CreditCard, ShieldCheck, UserCircle } from 'phosphor-react';

import { TestimonialsSlider } from '@/src/screen/components/prismic/TestimonialsSlider';

import styles from './styles.module.css';

type Reason = {
  icon: any;
  title: string;
  description: string;
};

const reasons: Reason[] = [
  {
    icon: ShieldCheck,
    title: 'Viagens seguras',
    description:
      'Com a Urbano Norte você tem a garantia de estar realizando viagens seguras, todos os motoristas são rigorosamente verificados!',
  },
  {
    icon: UserCircle,
    title: 'Motorista mulher',
    description:
      'Você se sente mais segura com uma condutora mulher? A Urbano Norte possui uma categoria exclusiva para você!',
  },
  {
    icon: CreditCard,
    title: 'Economia',
    description:
      'Com a Urbano Norte você realiza viagens rápidas de forma prática e ainda economiza. ',
  },
  {
    icon: Car,
    title: 'Categoria Premium',
    description:
      'Você é mais exigente? Use nossa categoria premium, os carros são sempre novos, com no máximo 2 anos de fabricação. ',
  },
];

export const Main = (): JSX.Element => {
  return (
    <section className="relative">
      <div className={styles.main}>
        <div className="py-24 spacing-x max-w-6xl w-full mx-auto">
          <section className="text-floor-white z-10 drop-shadow-md">
            <span className="text-1xl md:text-3xl font-semibold drop-shadow">
              Se precisar de transporte, vá de
            </span>
            <h1 className="text-5xl md:text-8xl font-bold drop-shadow">
              Urbano Norte.
            </h1>
          </section>

          <div className="flex p-6 mt-20 md:mt-28 flex-wrap justify-between bg-floor-white bg-opacity-80">
            {reasons.map(reason => (
              <div key="index" className="max-w-md p-6">
                <reason.icon size={25} color="#4ccd73" weight="fill" />

                <h4 className="mt-2 font-bold">{reason.title}</h4>
                <p className="mt-1">{reason.description}</p>
              </div>
            ))}
            {/* {Array.from({ length: 6 }, (_, index) => ({
              ...reasons[],
              id: index,
            })).map(reason => (
              <div key={reason.id} className="max-w-md p-6">
                <reason.icon size={25} color="#4ccd73" weight="fill" />

                <h4 className="mt-2 font-bold">{reason.title}</h4>
                <p className="mt-1">{reason.description}</p>
              </div>
            ))} */}
          </div>
        </div>
        <div className="bowl-content pb-4">
          <h1 className="text-center font-bold text-3xl md:text-6xl text-floor-white drop-shadow">
            O que nossos clientes acham.
          </h1>
        </div>
        <div className="pt-4">
          <TestimonialsSlider />
        </div>
      </div>
    </section>
  );
};
